/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { SubscriptionPagedList } from '../../models/subscription-paged-list';
import { SubscriptionSearch } from '../../models/subscription-search';

export interface SearchSubscriptions$Json$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;
  sortFieldName?: 'NAME' | 'CREATION_DATE' | 'NUMBER' | 'CITY' | 'STATE' | 'AUTH_SUPPORT_REQUESTED_NUMBER';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * The search text to filter API
 */
  search?: string;
  
    /**
     * Body for search subscription
     */
    body?: SubscriptionSearch
}

export function searchSubscriptions$Json(http: HttpClient, rootUrl: string, params?: SearchSubscriptions$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchSubscriptions$Json.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionPagedList>;
    })
  );
}

searchSubscriptions$Json.PATH = '/subscriptions/search';
